import React from "react";
import { Home as HomeIcon, User } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";

const items = [
  { label: "Início", icon: HomeIcon, path: "/home", testid: "nav-home" },
  { label: "Perfil", icon: User, path: "/perfil", testid: "nav-profile" },
];

export default function BottomNav() {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md bg-white dark:bg-slate-900 border-t border-slate-100 dark:border-slate-800 py-2 flex justify-center gap-20 items-center z-50 shadow-[0_-8px_24px_rgba(15,23,42,0.06)]"
    >
      {items.map(({ label, icon: Icon, path, testid }) => {
        const active = pathname === path || (path === "/home" && pathname === "/");
        return (
          <button
            key={path}
            data-testid={testid}
            onClick={() => navigate(path)}
            className={`flex flex-col items-center gap-1 text-xs font-medium py-1 transition-colors ${
              active ? "text-[#00D285]" : "text-slate-400 dark:text-slate-500 hover:text-slate-600 dark:hover:text-slate-300"
            }`}
          >
            <Icon size={22} strokeWidth={active ? 2.5 : 2} />
            <span>{label}</span>
          </button>
        );
      })}
    </nav>
  );
}
